module.exports = __webpack_public_path__ + "img/logo.9a6e01b8.png";